export default __webpack_public_path__ + "static/media/gdg-logo.0724bb14.png";